import { z } from 'zod';

/** Optional display hints carried by the validation JSON scalar. */
export const validationFieldHighlightsSchema = z.object({
  highlightFieldMappingKeys: z.array(z.string().min(1)).min(1).optional(),
});

export type ValidationFieldHighlights = z.infer<
  typeof validationFieldHighlightsSchema
>;
